import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeftIcon, BuildingIcon, MapPinIcon, GlobeIcon, MailIcon, PhoneIcon, UserIcon, CalendarIcon, ClockIcon, ChevronDownIcon, FileTextIcon, CheckCircleIcon, AlertCircleIcon, BarChart3Icon, TrendingUpIcon, DollarSignIcon, UsersIcon, ExternalLinkIcon, ChevronRightIcon, FilterIcon, SearchIcon, BellIcon, HelpCircleIcon } from 'lucide-react';
import { dealersData } from '../data/dealersData';
import { DealerMetrics } from '../components/dealers/DealerMetrics';
import { DealerQuotesTrend } from '../components/dealers/DealerQuotesTrend';
export function DealerDetailsPage() {
  const {
    dealerId
  } = useParams();
  const [timeRange, setTimeRange] = useState('6months');
  const [activeTab, setActiveTab] = useState('overview');
  // Find dealer data
  const dealer = dealersData.find(d => d.id === dealerId) || {
    id: 'D-12345',
    name: 'Texas International Irrigation',
    country: 'United States',
    region: 'Aisco AMERICA',
    address: '1234 Irrigation Blvd, Austin, TX 78701',
    email: 'contact@texasirrigation.com',
    phone: '+1 (512) 555-1234',
    website: 'www.texasirrigation.com',
    contactPerson: 'John Doe',
    totalQuotes: 167,
    activeQuotes: 32,
    totalRevenue: 2800000,
    customers: 45,
    conversionRate: 68,
    conversionTrend: 4.2,
    avgQuoteValue: 32500,
    targetQuoteValue: 40000,
    avgValueTrend: -2.1,
    avgResponseTime: 8,
    responseTrend: -15,
    approvedQuotes: 112,
    pendingQuotes: 38,
    rejectedQuotes: 12,
    expiredQuotes: 5,
    quotesHistory: [8, 12, 14, 9, 18, 22],
    lastActivity: '2 hours ago',
    joinedDate: 'Jan 15, 2020'
  };
  // Recent quotes data
  const recentQuotes = [{
    id: 'Q-78945',
    customer: 'Farmland Enterprises',
    product: 'Pivot Machine 8" 5/8 GALV',
    date: 'Jun 13, 2025',
    status: 'approved',
    amount: '$85,420.00'
  }, {
    id: 'Q-78932',
    customer: 'Green Valley Farms',
    product: 'Reeltown 1058 ft wiper',
    date: 'Jun 10, 2025',
    status: 'pending',
    amount: '$64,750.00'
  }, {
    id: 'Q-78921',
    customer: 'Sunset Agriculture',
    product: 'Pivot CP600',
    date: 'Jun 05, 2025',
    status: 'rejected',
    amount: '$72,180.00'
  }, {
    id: 'Q-78905',
    customer: 'Harvest Fields Inc.',
    product: 'Linear System L200',
    date: 'May 28, 2025',
    status: 'expired',
    amount: '$93,600.00'
  }];
  // Top customers data
  const topCustomers = [{
    name: 'Farmland Enterprises',
    quotes: 12,
    revenue: 420000
  }, {
    name: 'Green Valley Farms',
    quotes: 8,
    revenue: 310000
  }, {
    name: 'Sunset Agriculture',
    quotes: 7,
    revenue: 285000
  }, {
    name: 'Harvest Fields Inc.',
    quotes: 5,
    revenue: 210000
  }];
  return <div className="flex flex-col min-h-screen bg-gradient-to-br from-slate-900 to-blue-900" data-id="element-8235">
      {/* Header */}
      <header className="bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 border-b border-blue-800/30 relative z-10" data-id="element-8236">
        <div className="px-6 py-4 flex justify-between items-center" data-id="element-8237">
          <div className="flex items-center" data-id="element-8238">
            <Link to="/dealers" className="mr-3 text-blue-300 hover:text-white cursor-pointer transition-colors" data-id="element-8239">
              <ArrowLeftIcon size={20} data-id="element-8240" />
            </Link>
            <div className="p-2 mr-3 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-lg" data-id="element-8241">
              <BuildingIcon size={20} className="text-white" data-id="element-8242" />
            </div>
            <div data-id="element-8243">
              <h1 className="text-xl font-bold text-white" data-id="element-8244">{dealer.name}</h1>
              <p className="text-blue-200 text-sm hidden sm:block" data-id="element-8245">
                {dealer.country} - {dealer.region}
              </p>
            </div>
          </div>
          <div className="flex items-center space-x-3" data-id="element-8246">
            <div className="relative hidden sm:block" data-id="element-8247">
              <div className="relative" data-id="element-8248">
                <input type="text" placeholder="Search..." className="bg-white/10 border border-blue-800/30 rounded-full pl-10 pr-4 py-2 text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 w-56" data-id="element-8249" />
                <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-blue-300" size={18} data-id="element-8250" />
              </div>
            </div>
            <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-8251">
              <CalendarIcon size={20} data-id="element-8252" />
            </button>
            <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-8253">
              <BarChart3Icon size={20} data-id="element-8254" />
            </button>
            <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-8255">
              <HelpCircleIcon size={20} data-id="element-8256" />
            </button>
            <div className="relative" data-id="element-8257">
              <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-8258">
                <BellIcon size={20} data-id="element-8259" />
                <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full text-xs flex items-center justify-center text-white" data-id="element-8260">
                  3
                </span>
              </button>
            </div>
            <div className="flex items-center bg-white/10 hover:bg-white/15 rounded-full pl-2 pr-3 py-1 cursor-pointer transition-colors" data-id="element-8261">
              <div className="bg-gradient-to-br from-blue-600 to-indigo-700 rounded-full w-8 h-8 flex items-center justify-center mr-2" data-id="element-8262">
                <UserIcon size={16} className="text-white" data-id="element-8263" />
              </div>
              <span className="text-white text-sm font-medium hidden sm:block" data-id="element-8264">
                Daniel Alejandro
              </span>
              <ChevronDownIcon size={16} className="text-blue-300 ml-1 hidden sm:block" data-id="element-8265" />
            </div>
            <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors shadow-lg flex items-center" data-id="element-8266">
              <FileTextIcon size={16} className="mr-2" data-id="element-8267" />
              Nueva Cotización
            </button>
          </div>
        </div>
      </header>
      {/* Tabs */}
      <div className="px-6 py-4 border-b border-blue-800/30" data-id="element-8268">
        <div className="flex border-b border-blue-800" data-id="element-8269">
          <button className={`px-6 py-3 font-medium transition-colors ${activeTab === 'overview' ? 'text-white border-b-2 border-white' : 'text-blue-300 hover:text-white'}`} onClick={() => setActiveTab('overview')} data-id="element-8270">
            Overview
          </button>
          <button className={`px-6 py-3 font-medium transition-colors ${activeTab === 'quotes' ? 'text-white border-b-2 border-white' : 'text-blue-300 hover:text-white'}`} onClick={() => setActiveTab('quotes')} data-id="element-8271">
            Quotes
          </button>
          <button className={`px-6 py-3 font-medium transition-colors ${activeTab === 'customers' ? 'text-white border-b-2 border-white' : 'text-blue-300 hover:text-white'}`} onClick={() => setActiveTab('customers')} data-id="element-8272">
            Customers
          </button>
          <button className={`px-6 py-3 font-medium transition-colors ${activeTab === 'settings' ? 'text-white border-b-2 border-white' : 'text-blue-300 hover:text-white'}`} onClick={() => setActiveTab('settings')} data-id="element-8273">
            Settings
          </button>
        </div>
      </div>
      {/* Main content - using flex-1 to ensure it takes remaining space */}
      <div className="flex-1 p-6 overflow-auto" data-id="element-8274">
        {activeTab === 'overview' && <div className="space-y-6" data-id="element-8275">
            {/* Top cards */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-8276">
              <MetricCard title="Total Quotes" value={dealer.totalQuotes} icon={<FileTextIcon size={20} className="text-blue-500" data-id="element-8278" />} color="bg-gradient-to-br from-blue-600/10 to-indigo-600/10 border-blue-500/20" textColor="text-blue-500" subtitle={`${dealer.activeQuotes} active quotes`} data-id="element-8277" />
              <MetricCard title="Total Revenue" value={`$${(dealer.totalRevenue / 1000000).toFixed(1)}M`} icon={<DollarSignIcon size={20} className="text-green-500" data-id="element-8280" />} color="bg-gradient-to-br from-green-600/10 to-emerald-600/10 border-green-500/20" textColor="text-green-500" subtitle={`${dealer.customers} customers`} data-id="element-8279" />
              <MetricCard title="Conversion Rate" value={`${dealer.conversionRate}%`} icon={<TrendingUpIcon size={20} className="text-purple-500" data-id="element-8282" />} color="bg-gradient-to-br from-purple-600/10 to-pink-600/10 border-purple-500/20" textColor="text-purple-500" subtitle={`+${dealer.conversionTrend}% from last period`} trend={dealer.conversionTrend > 0 ? 'up' : 'down'} data-id="element-8281" />
              <MetricCard title="Avg. Response Time" value={`${dealer.avgResponseTime}h`} icon={<ClockIcon size={20} className="text-amber-500" data-id="element-8284" />} color="bg-gradient-to-br from-amber-600/10 to-orange-600/10 border-amber-500/20" textColor="text-amber-500" subtitle={`${Math.abs(dealer.responseTrend)}% from last period`} trend={dealer.responseTrend < 0 ? 'up' : 'down'} data-id="element-8283" />
            </div>
            {/* Time range selector */}
            <div className="flex justify-end" data-id="element-8285">
              <div className="inline-flex items-center rounded-lg border border-blue-800 overflow-hidden" data-id="element-8286">
                <button className={`px-3 py-1.5 text-sm ${timeRange === '30days' ? 'bg-blue-700 text-white' : 'text-blue-300 hover:bg-blue-800/50'}`} onClick={() => setTimeRange('30days')} data-id="element-8287">
                  30 Days
                </button>
                <button className={`px-3 py-1.5 text-sm ${timeRange === '3months' ? 'bg-blue-700 text-white' : 'text-blue-300 hover:bg-blue-800/50'}`} onClick={() => setTimeRange('3months')} data-id="element-8288">
                  3 Months
                </button>
                <button className={`px-3 py-1.5 text-sm ${timeRange === '6months' ? 'bg-blue-700 text-white' : 'text-blue-300 hover:bg-blue-800/50'}`} onClick={() => setTimeRange('6months')} data-id="element-8289">
                  6 Months
                </button>
                <button className={`px-3 py-1.5 text-sm ${timeRange === '1year' ? 'bg-blue-700 text-white' : 'text-blue-300 hover:bg-blue-800/50'}`} onClick={() => setTimeRange('1year')} data-id="element-8290">
                  1 Year
                </button>
              </div>
            </div>
            {/* Dealer info and metrics */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-8291">
              {/* Dealer info */}
              <div className="bg-white/5 backdrop-blur-sm rounded-xl border border-white/10 overflow-hidden" data-id="element-8292">
                <div className="p-5 border-b border-white/10" data-id="element-8293">
                  <h3 className="font-medium text-white flex items-center" data-id="element-8294">
                    <UserIcon size={16} className="mr-2 text-blue-400" data-id="element-8295" />
                    Dealer Information
                  </h3>
                </div>
                <div className="p-5" data-id="element-8296">
                  <div className="space-y-4" data-id="element-8297">
                    <div data-id="element-8298">
                      <div className="text-sm text-blue-300" data-id="element-8299">Address</div>
                      <div className="text-white" data-id="element-8300">{dealer.address}</div>
                    </div>
                    <div data-id="element-8301">
                      <div className="text-sm text-blue-300" data-id="element-8302">
                        Contact Person
                      </div>
                      <div className="text-white" data-id="element-8303">{dealer.contactPerson}</div>
                    </div>
                    <div data-id="element-8304">
                      <div className="text-sm text-blue-300" data-id="element-8305">Email</div>
                      <div className="text-white" data-id="element-8306">{dealer.email}</div>
                    </div>
                    <div data-id="element-8307">
                      <div className="text-sm text-blue-300" data-id="element-8308">Phone</div>
                      <div className="text-white" data-id="element-8309">{dealer.phone}</div>
                    </div>
                    <div data-id="element-8310">
                      <div className="text-sm text-blue-300" data-id="element-8311">Website</div>
                      <div className="text-white flex items-center" data-id="element-8312">
                        {dealer.website}
                        <ExternalLinkIcon size={14} className="ml-1 text-blue-400" data-id="element-8313" />
                      </div>
                    </div>
                    <div className="flex justify-between pt-2" data-id="element-8314">
                      <div data-id="element-8315">
                        <div className="text-sm text-blue-300" data-id="element-8316">
                          Last Activity
                        </div>
                        <div className="text-white" data-id="element-8317">{dealer.lastActivity}</div>
                      </div>
                      <div className="text-right" data-id="element-8318">
                        <div className="text-sm text-blue-300" data-id="element-8319">Joined</div>
                        <div className="text-white" data-id="element-8320">{dealer.joinedDate}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Quote metrics and trends */}
              <div className="lg:col-span-2" data-id="element-8321">
                <div className="bg-gradient-to-br from-blue-900/30 to-indigo-900/30 backdrop-blur-sm rounded-xl border border-blue-500/20 overflow-hidden" data-id="element-8322">
                  <div className="p-5 border-b border-blue-800/30" data-id="element-8323">
                    <h3 className="font-medium text-white flex items-center" data-id="element-8324">
                      <BarChart3Icon size={16} className="mr-2 text-blue-400" data-id="element-8325" />
                      Quote Performance Metrics
                    </h3>
                  </div>
                  <div className="p-5" data-id="element-8326">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-8327">
                      {/* Quote Status Distribution */}
                      <div data-id="element-8328">
                        <h4 className="text-sm font-medium text-blue-300 mb-4" data-id="element-8329">
                          Quote Status Distribution
                        </h4>
                        <div className="space-y-4" data-id="element-8330">
                          <QuoteStatusBar label="Approved" value={dealer.approvedQuotes} total={dealer.totalQuotes} color="bg-green-500" data-id="element-8331" />
                          <QuoteStatusBar label="Pending" value={dealer.pendingQuotes} total={dealer.totalQuotes} color="bg-amber-500" data-id="element-8332" />
                          <QuoteStatusBar label="Rejected" value={dealer.rejectedQuotes} total={dealer.totalQuotes} color="bg-red-500" data-id="element-8333" />
                          <QuoteStatusBar label="Expired" value={dealer.expiredQuotes} total={dealer.totalQuotes} color="bg-gray-500" data-id="element-8334" />
                        </div>
                      </div>
                      {/* Quote Value Analysis */}
                      <div data-id="element-8335">
                        <h4 className="text-sm font-medium text-blue-300 mb-4" data-id="element-8336">
                          Quote Value Analysis
                        </h4>
                        <div className="space-y-6" data-id="element-8337">
                          <div data-id="element-8338">
                            <div className="flex justify-between items-center mb-1" data-id="element-8339">
                              <div className="text-sm text-blue-200" data-id="element-8340">
                                Average Quote Value
                              </div>
                              <div className="text-sm font-medium text-white" data-id="element-8341">
                                ${dealer.avgQuoteValue.toLocaleString()}
                              </div>
                            </div>
                            <div className="w-full bg-blue-900/50 rounded-full h-2.5" data-id="element-8342">
                              <div className="bg-blue-500 h-2.5 rounded-full" style={{
                            width: `${Math.min(dealer.avgQuoteValue / dealer.targetQuoteValue * 100, 100)}%`
                          }} data-id="element-8343"></div>
                            </div>
                            <div className="flex justify-between text-xs mt-1" data-id="element-8344">
                              <span className="text-blue-300" data-id="element-8345">$0</span>
                              <span className="text-blue-300" data-id="element-8346">
                                Target: $
                                {dealer.targetQuoteValue.toLocaleString()}
                              </span>
                            </div>
                          </div>
                          <div data-id="element-8347">
                            <div className="flex justify-between items-center mb-1" data-id="element-8348">
                              <div className="text-sm text-blue-200" data-id="element-8349">
                                Conversion Rate
                              </div>
                              <div className="text-sm font-medium text-white" data-id="element-8350">
                                {dealer.conversionRate}%
                              </div>
                            </div>
                            <div className="w-full bg-blue-900/50 rounded-full h-2.5" data-id="element-8351">
                              <div className="bg-purple-500 h-2.5 rounded-full" style={{
                            width: `${dealer.conversionRate}%`
                          }} data-id="element-8352"></div>
                            </div>
                            <div className="flex justify-between text-xs mt-1" data-id="element-8353">
                              <span className="text-blue-300" data-id="element-8354">0%</span>
                              <span className="text-blue-300" data-id="element-8355">100%</span>
                            </div>
                          </div>
                          <div className="pt-4" data-id="element-8356">
                            <h5 className="text-sm font-medium text-blue-300 mb-2" data-id="element-8357">
                              Performance Indicators
                            </h5>
                            <div className="grid grid-cols-2 gap-3" data-id="element-8358">
                              <div className="bg-blue-900/30 p-3 rounded-lg" data-id="element-8359">
                                <div className="text-xs text-blue-300" data-id="element-8360">
                                  Response Time
                                </div>
                                <div className="text-lg font-medium text-white" data-id="element-8361">
                                  {dealer.avgResponseTime}h
                                </div>
                                <div className="text-xs text-green-400 flex items-center" data-id="element-8362">
                                  <TrendingUpIcon size={12} className="mr-1" data-id="element-8363" />
                                  15% faster
                                </div>
                              </div>
                              <div className="bg-blue-900/30 p-3 rounded-lg" data-id="element-8364">
                                <div className="text-xs text-blue-300" data-id="element-8365">
                                  Quotes per Month
                                </div>
                                <div className="text-lg font-medium text-white" data-id="element-8366">
                                  {Math.round(dealer.totalQuotes / 6)}
                                </div>
                                <div className="text-xs text-green-400 flex items-center" data-id="element-8367">
                                  <TrendingUpIcon size={12} className="mr-1" data-id="element-8368" />
                                  8% increase
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Quotes trend chart */}
            <div className="bg-gradient-to-br from-blue-900/30 to-indigo-900/30 backdrop-blur-sm rounded-xl border border-blue-500/20 overflow-hidden" data-id="element-8369">
              <div className="p-5 border-b border-blue-800/30 flex justify-between items-center" data-id="element-8370">
                <h3 className="font-medium text-white flex items-center" data-id="element-8371">
                  <TrendingUpIcon size={16} className="mr-2 text-blue-400" data-id="element-8372" />
                  Quotes & Revenue Trend
                </h3>
                <div className="text-sm text-blue-300 flex items-center" data-id="element-8373">
                  <CalendarIcon size={14} className="mr-1" data-id="element-8374" />
                  {timeRange === '30days' ? 'Last 30 days' : timeRange === '3months' ? 'Last 3 months' : timeRange === '6months' ? 'Last 6 months' : timeRange === '1year' ? 'Last 12 months' : 'All time'}
                </div>
              </div>
              <div className="p-5" data-id="element-8375">
                <div className="h-80 relative" data-id="element-8376">
                  {/* This would be a real chart in production */}
                  <div className="absolute inset-0 flex items-end justify-between px-2" data-id="element-8377">
                    {Array.from({
                  length: timeRange === '30days' ? 6 : timeRange === '3months' ? 3 : timeRange === '6months' ? 6 : 12
                }, (_, i) => <div key={i} className="flex flex-col items-center" data-id="element-8378">
                          <div className="relative" data-id="element-8379">
                            {/* Revenue Bar */}
                            <div className="w-8 bg-green-500/60 rounded-t-sm" style={{
                      height: `${Math.random() * 100 + 50}px`
                    }} data-id="element-8380"></div>
                            {/* Quote Bar */}
                            <div className="w-6 bg-blue-500 rounded-t-sm absolute top-0 left-1" style={{
                      height: `${Math.random() * 80 + 30}px`
                    }} data-id="element-8381"></div>
                          </div>
                          <div className="text-xs text-blue-300 mt-2" data-id="element-8382">
                            {timeRange === '30days' ? `Day ${i * 5 + 1}` : timeRange === '3months' ? ['Jan', 'Feb', 'Mar'][i] : timeRange === '6months' ? ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'][i] : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][i]}
                          </div>
                        </div>)}
                  </div>
                </div>
                {/* Legend */}
                <div className="flex items-center justify-center space-x-6 mt-4" data-id="element-8383">
                  <div className="flex items-center" data-id="element-8384">
                    <div className="w-3 h-3 rounded-full bg-blue-500 mr-2" data-id="element-8385"></div>
                    <span className="text-sm text-blue-200" data-id="element-8386">Quotes</span>
                  </div>
                  <div className="flex items-center" data-id="element-8387">
                    <div className="w-3 h-3 rounded-full bg-green-500/60 mr-2" data-id="element-8388"></div>
                    <span className="text-sm text-blue-200" data-id="element-8389">Revenue</span>
                  </div>
                </div>
              </div>
            </div>
            {/* Recent quotes and top customers */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-8390">
              {/* Recent quotes */}
              <div className="bg-white/5 backdrop-blur-sm rounded-xl border border-white/10 overflow-hidden" data-id="element-8391">
                <div className="p-5 border-b border-white/10 flex justify-between items-center" data-id="element-8392">
                  <h3 className="font-medium text-white flex items-center" data-id="element-8393">
                    <FileTextIcon size={16} className="mr-2 text-blue-400" data-id="element-8394" />
                    Recent Quotes
                  </h3>
                  <button className="text-blue-300 hover:text-white text-sm flex items-center" data-id="element-8395">
                    View all
                    <ChevronRightIcon size={14} className="ml-1" data-id="element-8396" />
                  </button>
                </div>
                <div className="divide-y divide-white/10" data-id="element-8397">
                  {recentQuotes.map(quote => <div key={quote.id} className="p-4 hover:bg-white/5 transition-colors" data-id="element-8398">
                      <div className="flex justify-between" data-id="element-8399">
                        <div data-id="element-8400">
                          <div className="flex items-center" data-id="element-8401">
                            <span className="text-white font-medium" data-id="element-8402">
                              {quote.customer}
                            </span>
                            <span className="ml-2 px-2 py-0.5 bg-white/10 rounded-full text-xs text-blue-200" data-id="element-8403">
                              {quote.id}
                            </span>
                          </div>
                          <div className="text-blue-200 text-sm mt-1" data-id="element-8404">
                            {quote.product}
                          </div>
                        </div>
                        <div className="text-right" data-id="element-8405">
                          <div className="text-white font-medium" data-id="element-8406">
                            {quote.amount}
                          </div>
                          <div className="text-blue-300 text-xs mt-1 flex items-center justify-end" data-id="element-8407">
                            <CalendarIcon size={12} className="mr-1" data-id="element-8408" />
                            {quote.date}
                          </div>
                        </div>
                      </div>
                      <div className="mt-2 flex justify-between items-center" data-id="element-8409">
                        <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${quote.status === 'approved' ? 'bg-green-500/20 text-green-300' : quote.status === 'pending' ? 'bg-amber-500/20 text-amber-300' : quote.status === 'rejected' ? 'bg-red-500/20 text-red-300' : 'bg-gray-500/20 text-gray-300'}`} data-id="element-8410">
                          {quote.status === 'approved' ? <>
                              <CheckCircleIcon size={12} className="mr-1" data-id="element-8411" />
                              Approved
                            </> : quote.status === 'pending' ? <>
                              <ClockIcon size={12} className="mr-1" data-id="element-8412" />
                              Pending
                            </> : quote.status === 'rejected' ? <>
                              <AlertCircleIcon size={12} className="mr-1" data-id="element-8413" />
                              Rejected
                            </> : <>
                              <ClockIcon size={12} className="mr-1" data-id="element-8414" />
                              Expired
                            </>}
                        </span>
                        <button className="text-blue-400 hover:text-white text-sm" data-id="element-8415">
                          View details
                        </button>
                      </div>
                    </div>)}
                </div>
              </div>
              {/* Top customers */}
              <div className="bg-white/5 backdrop-blur-sm rounded-xl border border-white/10 overflow-hidden" data-id="element-8416">
                <div className="p-5 border-b border-white/10 flex justify-between items-center" data-id="element-8417">
                  <h3 className="font-medium text-white flex items-center" data-id="element-8418">
                    <UsersIcon size={16} className="mr-2 text-blue-400" data-id="element-8419" />
                    Top Customers
                  </h3>
                  <button className="text-blue-300 hover:text-white text-sm flex items-center" data-id="element-8420">
                    View all
                    <ChevronRightIcon size={14} className="ml-1" data-id="element-8421" />
                  </button>
                </div>
                <div className="divide-y divide-white/10" data-id="element-8422">
                  {topCustomers.map((customer, index) => <div key={index} className="p-4 hover:bg-white/5 transition-colors" data-id="element-8423">
                      <div className="flex justify-between items-center" data-id="element-8424">
                        <div className="flex items-center" data-id="element-8425">
                          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white font-medium mr-3" data-id="element-8426">
                            {customer.name.charAt(0)}
                          </div>
                          <div data-id="element-8427">
                            <div className="text-white font-medium" data-id="element-8428">
                              {customer.name}
                            </div>
                            <div className="text-blue-300 text-xs mt-0.5" data-id="element-8429">
                              {customer.quotes} quotes
                            </div>
                          </div>
                        </div>
                        <div className="text-right" data-id="element-8430">
                          <div className="text-white font-medium" data-id="element-8431">
                            ${customer.revenue.toLocaleString()}
                          </div>
                          <div className="text-blue-300 text-xs mt-0.5" data-id="element-8432">
                            Total revenue
                          </div>
                        </div>
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
          </div>}
        {/* Other tabs would be implemented here */}
        {activeTab !== 'overview' && <div className="flex items-center justify-center h-64 text-blue-300" data-id="element-8433">
            {activeTab.charAt(0).toUpperCase() + activeTab.slice(1)} content is
            under development
          </div>}
      </div>
    </div>;
}
// Helper components
function MetricCard({
  title,
  value,
  icon,
  color,
  textColor,
  subtitle,
  trend
}) {
  return <div className={`rounded-xl p-5 ${color}`} data-id="element-8434">
      <div className="flex justify-between items-start" data-id="element-8435">
        <div data-id="element-8436">
          <div className="text-sm text-blue-300" data-id="element-8437">{title}</div>
          <div className={`text-2xl font-bold mt-1 ${textColor}`} data-id="element-8438">{value}</div>
        </div>
        <div className={`p-2 rounded-lg ${textColor.replace('text', 'bg')}/20`} data-id="element-8439">
          {icon}
        </div>
      </div>
      {subtitle && <div className="mt-2 text-xs flex items-center" data-id="element-8440">
          {trend ? trend === 'up' ? <TrendingUpIcon size={12} className="mr-1 text-green-500" data-id="element-8441" /> : <TrendingUpIcon size={12} className="mr-1 text-red-500 transform rotate-180" data-id="element-8442" /> : null}
          <span className={trend === 'up' ? 'text-green-500' : trend === 'down' ? 'text-red-500' : 'text-blue-300'} data-id="element-8443">
            {subtitle}
          </span>
        </div>}
    </div>;
}
function QuoteStatusBar({
  label,
  value,
  total,
  color
}) {
  const percentage = Math.round(value / total * 100);
  return <div className="space-y-1" data-id="element-8444">
      <div className="flex justify-between" data-id="element-8445">
        <div className="flex items-center text-sm text-blue-200" data-id="element-8446">
          <div className={`w-3 h-3 rounded-full ${color} mr-2`} data-id="element-8447"></div>
          {label}
        </div>
        <div className="text-sm text-white font-medium" data-id="element-8448">
          {value} ({percentage}%)
        </div>
      </div>
      <div className="w-full bg-blue-900/50 rounded-full h-2" data-id="element-8449">
        <div className={`${color} h-2 rounded-full`} style={{
        width: `${percentage}%`
      }} data-id="element-8450"></div>
      </div>
    </div>;
}